#import "../fragments/contact-page-fragment.graphql"

query GetContact($id: ID!) {
    contact(id: $id) {
        ...ContactPageFragment
    }
}
